module.exports = __webpack_public_path__ + "static/media/placeholder.60c93809.svg";